// TODO replace with i18n
export const validationMessages = {
  required: 'This field is required',
} as const;

export default validationMessages;
